// extracted by mini-css-extract-plugin
export default {"route-transition":"route-transition_route-transition__ZssGS","routeFadeUp":"route-transition_routeFadeUp__4ftTG"};